"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemStatusReady = exports.SystemStatusSetMesage = exports.SYSTEM_STATUS_READY = exports.SYSTEM_STATUS_MESSAGE_SET = void 0;
/**
 * @ReduxAction A System Status Message is set
 */
exports.SYSTEM_STATUS_MESSAGE_SET = 'SYSTEM_STATUS_MESSAGE_SET';
/**
 * @ReduxAction SystemStatus Module is ready
 */
exports.SYSTEM_STATUS_READY = 'SYSTEM_STATUS_READY';
const SystemStatusSetMesage = (systemStatusMessageInfo) => ({
    type: exports.SYSTEM_STATUS_MESSAGE_SET,
    systemStatusMessageInfo,
});
exports.SystemStatusSetMesage = SystemStatusSetMesage;
const SystemStatusReady = () => ({
    type: exports.SYSTEM_STATUS_READY,
});
exports.SystemStatusReady = SystemStatusReady;
